import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import * as user from '../actions/user';
import * as auth from '../actions/auth.actions';
var initialState = {
    error: null,
    loading: false,
    context: null,
    customerSelected: null
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case user.GET:
            return tslib_1.__assign({}, state, { loading: true });
        case user.GET_SUCCESS:
            return tslib_1.__assign({}, state, { context: action.payload, loading: false });
        case user.GET_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload, loading: false });
        case user.SET_SUCCESS:
            return tslib_1.__assign({}, state, { context: tslib_1.__assign({}, state.context, { preferences: action.payload }) });
        case user.SET_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload });
        case user.SELECT_CUSTOMER:
            return tslib_1.__assign({}, state, { customerSelected: '', context: tslib_1.__assign({}, state.context, { customer: {} }) });
        case user.SET_CUSTOMER:
            return tslib_1.__assign({}, state, { customerSelected: action.payload });
        case user.SET_CUSTOMER_SUCCESS:
            return tslib_1.__assign({}, state, { context: tslib_1.__assign({}, state.context, { customer: action.payload }) });
        case user.SET_CUSTOMER_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload });
        case auth.LOGOUT:
            return initialState;
        default:
            return state;
    }
}
export var getUserState = function (state) { return state; };
export var getUserContext = function (state) { return state.context; };
export var getError = function (state) { return state.error; };
export var isLoading = function (state) { return state.loading; };
export var getAddresses = createSelector(getUserContext, function (user) { return (user && user.customer && user.customer.addresses) || []; });
export var getCustomerCurrency = createSelector(getUserContext, function (user) { return (user && user.customer && user.customer.currency) || 'EUR'; });
export var getLanguage = createSelector(getUserContext, function (context) { return context && context.preferences && context.preferences.language; });
export var getUserId = createSelector(getUserContext, function (context) { return context && context._id; });
export var getCustomerInfo = createSelector(getUserContext, function (context) { return context && context.customer; });
export var getCurrentTenant = createSelector(getUserContext, function (context) { return context && context.tenantName; });
export var getCustomerId = createSelector(getCustomerInfo, function (customer) { return customer && customer._id; });
export var getCustomerMinOrderValue = createSelector(getCustomerInfo, function (customer) { return customer && customer.minOrderValue; });
export var getCustomerDiscounts = createSelector(getCustomerInfo, function (customer) { return customer && customer.discounts; });
export var getUserPermissions = createSelector(getUserContext, function (context) { return context && context.permissions; });
